<div class="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
  <div class="card shadow form-container">
    <div class="text-center login-form-message">
      <img src="https://cdn-icons-png.flaticon.com/512/3176/3176367.png" alt="Logo" width="40">
      <h4 class="mt-2">Reset Password</h4>
    </div>
    <form [formGroup]="configurePasswordForm">
      <div class="mb-3">
        <div class="password-rules mb-2">
          <p class="muted-text fs-14">In order to <strong>protect your account</strong>, make sure your Password must
            contain at least:</p>
          <ul class="list-unstyled ms-3 muted-text fs-14">
            <li>Eight characters</li>
            <li>One lowercase alphabet (a-z)</li>
            <li>One uppercase alphabet (A-Z)</li>
            <li>One numeric value (1-9)</li>
            <li>One special character (!&#64;#$%^&*)</li>
          </ul>
        </div>
      </div>
      <div class="mb-3">
        <div class="position-relative">
          <input [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
            class="form-control password-form-control" placeholder="New Password" />
          <i class="bi position-absolute top-50 end-0 translate-middle-y me-3 password-icon"
            [ngClass]="showNewPassword ? 'bi-eye' : 'bi-eye-slash'" (click)="toggleNewPassword()"></i>
        </div>
        @if (configurePasswordForm?.get('newPassword')?.touched) {
        @if (configurePasswordForm?.get('newPassword')?.hasError('required')) {
        <small class="error-msg">{{ messages?.FIELD_REQUIRED }}</small>
        }
        @if (configurePasswordForm?.get('newPassword')?.hasError('pattern')) {
        <small class="error-msg">{{ messages?.INCORRECT_PASSWORD_PATTERN }}</small>
        }
        }
      </div>
      <div class="mb-3">
        <div class="position-relative">
          <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
            class="form-control password-form-control" placeholder="Confirm Password" />
          <i class="bi position-absolute top-50 end-0 translate-middle-y me-3 password-icon"
            [ngClass]="showConfirmPassword ? 'bi-eye' : 'bi-eye-slash'" (click)="toggleConfirmPassword()"></i>
        </div>
        @if (configurePasswordForm?.get('confirmPassword')?.touched) {
        @if (configurePasswordForm?.get('confirmPassword')?.hasError('required')) {
        <small class="error-msg">{{ messages?.FIELD_REQUIRED }}</small>
        }
        @if (configurePasswordForm?.get('confirmPassword')?.hasError('mismatch')) {
        <small class="error-msg">{{ messages?.PASSWORD_MISMATCH }}</small>
        }
        }
      </div>
      <div class="text-center">
        <button type="button" class="btn btn-primary w-100 mb-3 save-btn" (click)="onSave()" data-control="save-btn">
          Save
        </button>
      </div>
    </form>
  </div>
</div>